<template>
  <v-container class="grey lighten-4" fluid>
    <main-menu ref="homeMainMenu" :menuOptions="menuOptions" fixed></main-menu>
    <MenuFab></MenuFab>

    <v-container id="MainImage" class="d-flex justify-center pa-0">
      <div class="main-header-image-box">
        <img
          ref="mainHeaderImage"
          v-resize="onResize"
          src="@/assets/FrogiGo_Site_Main.jpg"
          class="main-header-image"
          usemap="#mainHeaderMap"
          @load="onResize"
          alt="home header image"
        />
        <button
          v-if="showButtons"
          class="image-button"
          ref="imageLogin"
          plain
          @click="openLoginDialog"
        >
          登入
        </button>
        <button
          v-if="showButtons"
          class="image-button"
          ref="imageRegister"
          plain
          @click="openRegisterDialog"
        >
          註冊
        </button>
      </div>
    </v-container>

    <CommonContentArea
      id="CompanyInfo"
      storeKey="COMPANY_PROFILE"
    ></CommonContentArea>

    <CommonContentArea
      id="CustomerNotice"
      storeKey="CUSTOMER_NOTICE"
      bgcolor="primary"
    ></CommonContentArea>

    <CommonContentArea
      id="ProhibitedGoods"
      storeKey="PROHIBITED_GOODS"
    ></CommonContentArea>

    <CommonContentArea
      id="Pricing"
      storeKey="PRICING"
      bgcolor="darken1"
      classname="white--text"
    ></CommonContentArea>

    <SpotInquiry id="spot_inquiry"></SpotInquiry>

    <!-- <v-divider class="mx-16"></v-divider>

    <CommonContentArea id="Tutorial" storeKey="TUTORIAL"></CommonContentArea> -->

    <Footer id="Footer"></Footer>
  </v-container>
</template>

<script>
// mdiFrequentlyAskedQuestions
import {
  GetAppLatestVersions,
  InsertMemberDevice,
  SetMessageRead,
} from "@/api/publicServices";
import {
  mdiArrowUpBold,
  mdiSchool,
  mdiPageLayoutFooter,
  mdiCancel,
  mdiDotsVertical,
  mdiClose,
} from "@mdi/js";
export default {
  name: "Home",
  metaInfo() {
    return {
      title: "FrogiGo 青蛙集運",
      meta: [
        {
          name: "description",
          content:
            "FrogiGo (青蛙集運)致力為青蛙用户提供一個簡單、快捷、可靠的一站式集運服務",
        },
        {
          property: "og:title",
          content:
            "FrogiGo (青蛙集運)致力為青蛙用户提供一個簡單、快捷、可靠的一站式集運服務",
        },
        { property: "og:site_name", content: "FrogiGo青蛙集運" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  data: () => ({
    menuOptions: [
      "self-pick-spot",
      "pricing",
      "faq",
      "login",
      "register",
      "locale",
      "news",
    ],

    fab: false,

    //cal position
    showButtons: true,
    loginPos: { top: 272, left: 315 },
    registerPos: { top: 320, left: 315 },
    loginRatio: { calculated: false, width: 0, height: 0 },
    registerRatio: { calculated: false, width: 0, height: 0 },

    //onmessage event
    messagePort: null,

    //svg icons
    mdiArrowUpBold,
    mdiSchool,
    mdiPageLayoutFooter,
    mdiCancel,
    mdiDotsVertical,
    mdiClose,
  }),
  created() {
    localStorage.setItem("isGetWebsiteBasicContentVer", "false");
    console.log("isGetWebsiteBasicContentVer");
  },
  async mounted() {
    console.log("Home mounted");
    if (window.location.hash != "") {
      let fragment = window.location.hash;
      console.log(window.location.hash);
      if (fragment == "#flutter") {
        localStorage.setItem("flutter", true);

        // add message listener
        // console.log("addEventListener message");
        // window.addEventListener("message", this.messageHandler, true);

        // app version
        try {
          const response = await GetAppLatestVersions();
          console.log(response.data);
          let appVers = { ANDROID: {}, IOS: {} };
          response.data.forEach((element) => {
            if (
              element["AppType"] == "ANDROID" ||
              element["AppType"] == "IOS"
            ) {
              appVers[element["AppType"]] = element;
            }
          });
          console.log(appVers);
          window.flutter_inappwebview.callHandler(
            "flutterAppVersionHandler",
            appVers
          );
        } catch (error) {
          console.log(error);
        }

        //update device token
        //add message listener
        window.addEventListener(
          "flutterFcmUpdateDeviceEvent",
          this.flutterFcmUpdateDeviceEvent,
          false
        );

        //update message notification to read
        window.addEventListener(
          "flutterFcmNotificaitonEvent",
          this.flutterFcmNotificaitonEvent,
          false
        );
      } else {
        setTimeout(() => {
          let toFragment = document.querySelector(fragment);
          console.log(toFragment);
          if (toFragment != null) {
            console.log(toFragment.scrollHeight);
            this.$vuetify.goTo(toFragment, { offset: 65 });
          }
        }, 1000);
      }
    }
    //console.log(this.$route.query);
    if (this.$route.query.relogin) {
      this.openLoginDialog();
    }
    this.onResize();
  },
  methods: {
    async flutterFcmUpdateDeviceEvent(event) {
      try {
        console.log(`flutterFcmUpdateDeviceEvent: ${event.detail}`);
        let data = {
          model: {
            MemberNo: localStorage.getItem("member_no"),
            DeviceID: localStorage.getItem("FLUTTER_DEVICE_ID"),
            DeviceToken: localStorage.getItem("FLUTTER_DEVICE_TOKEN"),
          },
        };
        await InsertMemberDevice(data);
      } catch (error) {
        console.log(`flutterFcmUpdateDeviceEvent: ${error}`);
      }
    },
    async flutterFcmNotificaitonEvent(event) {
      try {
        console.log(`flutterFcmNotificaitonEvent: ${event.detail}`);
        let data = {
          ID: event.detail.MESSAGE_ID,
        };
        await SetMessageRead(data);
      } catch (error) {
        console.log(`flutterFcmNotificaitonEvent: ${error}`);
      }
    },
    messageHandler(event) {
      console.log(`messageHandler 1: ${event}`);
      if (typeof event.data == "string") {
        console.log(`messageHandler 2: ${event}`);
        try {
          let message = JSON.parse(event.data);
          if (message.messageType == "FLUTTER") {
            if (event.ports[0] != null) {
              this.messagePort = event.ports[0];
              this.messagePort.onmessage = function (event) {
                // event.data contains the message data coming from the Dart side
                console.log(event.data.result);
              };
            }
          }
        } catch (error) {
          console.log(`messageHandler: ${error}`);
        }
      }
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      //console.log(this.windowSize);
      this.showButtons = true;
      const mainHeaderImage = this.$refs.mainHeaderImage;
      const imageLogin = this.$refs.imageLogin;
      const imageRegister = this.$refs.imageRegister;

      if (!this.loginRatio.calculated) {
        this.loginRatio.width =
          mainHeaderImage.naturalWidth / this.loginPos.left;
        this.loginRatio.height =
          mainHeaderImage.naturalHeight / this.loginPos.top;
      }
      if (!this.registerRatio.calculated) {
        this.registerRatio.width =
          mainHeaderImage.naturalWidth / this.registerPos.left;
        this.registerRatio.height =
          mainHeaderImage.naturalHeight / this.registerPos.top;
      }

      //cal new position
      const newLoginPos = {
        left: Math.floor(mainHeaderImage.clientWidth / this.loginRatio.width),
        top: Math.floor(mainHeaderImage.clientHeight / this.loginRatio.height),
      };
      const newRegisterPos = {
        left: Math.floor(
          mainHeaderImage.clientWidth / this.registerRatio.width
        ),
        top: Math.floor(
          mainHeaderImage.clientHeight / this.registerRatio.height
        ),
      };
      let newFontSize =
        (2 / mainHeaderImage.naturalWidth) * mainHeaderImage.clientWidth;
      if (newFontSize < 0.8) newFontSize = 0.8;

      // console.log(newLoginPos);
      // console.log(newRegisterPos);
      // console.log(imageLogin);
      // console.log(imageRegister);
      imageLogin.setAttribute(
        `style`,
        `top:${newLoginPos.top}px;left:${newLoginPos.left}px;font-size:${newFontSize}em;`
      );
      imageRegister.setAttribute(
        `style`,
        `top:${newRegisterPos.top}px;left:${newRegisterPos.left}px;font-size:${newFontSize}em;`
      );
      //console.log(mainHeaderImage.naturalWidth, mainHeaderImage.naturalHeight);
      //console.log(mainHeaderImage.clientWidth, mainHeaderImage.clientHeight);
    },
    openRegisterDialog() {
      //this.$router.push({ name: "register" }).catch(() => {});
      var homeMainMenu = this.$refs.homeMainMenu;
      homeMainMenu.openRegisterDialog();
    },
    openLoginDialog() {
      var homeMainMenu = this.$refs.homeMainMenu;
      homeMainMenu.openLoginDialog();
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    goTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
.cdx-simple-image__caption:empty {
  display: none;
}
.image-tool__caption:empty {
  display: none;
}
code.inline-code {
  color: #b44437 !important;
}
.main-header-image-box {
  position: relative;
}
.main-header-image {
  max-width: 100%;
  max-height: 100vh;
  object-fit: cover;
}
.image-button {
  position: absolute;
  display: block;
  font-size: 2em;
  margin-block-start: 0.3em;
  margin-block-end: 0.3em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

html {
  scroll-padding-top: 4rem;
}
</style>
